import type { Movie } from "@/types/content";

export const movies: Movie[] = [
  {
    id: "xingchen-zhixia",
    title: "星辰之下",
    type: "movie",
    genres: ["科幻", "冒险", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.7,
    duration: "142分钟",
    director: "陆沉舟",
    cast: ["江屿", "苏晚", "顾青川"],
    synopsis:
      "一名天体物理学家在观测站发现来自深空的异常信号，为揭开真相，她踏上穿越荒原与星空的旅程，重新审视人类与宇宙的关系。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20illustration%20of%20a%20lone%20figure%20gazing%20at%20a%20vast%20starry%20night%20sky%20above%20a%20glowing%20observatory%2C%20deep%20navy%20and%20amber%20tones%2C%20dramatic%20atmospheric%20lighting%2C%20minimalist%20composition%2C%20film%20grain%20texture&width=400&height=600&seq=mv-xingchen-01&orientation=portrait",
    tags: ["热播", "口碑佳作"],
    hot: true,
  },
  {
    id: "miwu-zhuixiong",
    title: "迷雾追凶",
    type: "movie",
    genres: ["悬疑", "犯罪", "惊悚"],
    region: "中国香港",
    year: 2024,
    rating: 8.2,
    duration: "118分钟",
    director: "导演何岸",
    cast: ["梁正", "文咏珊", "林家栋"],
    synopsis:
      "一宗尘封十年的旧案在雨夜重启，刑警与嫌疑人之间展开一场心理博弈，真相在层层迷雾中缓缓浮现，每个人都藏着秘密。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20illustration%20of%20a%20rainy%20foggy%20city%20street%20at%20night%20with%20a%20mysterious%20silhouette%20walking%20under%20a%20single%20lamp%2C%20moody%20blue%20and%20orange%20contrast%2C%20film%20noir%20atmosphere%2C%20minimalist%20composition&width=400&height=600&seq=mv-miwu-02&orientation=portrait",
    tags: ["悬疑", "烧脑"],
    hot: true,
  },
  {
    id: "changye-jiangming",
    title: "长夜将明",
    type: "tv",
    genres: ["剧情", "历史", "年代"],
    region: "中国大陆",
    year: 2025,
    rating: 9.1,
    duration: "全32集",
    director: "沈砚",
    cast: ["张远", "周冬雨", "王景春"],
    synopsis:
      "跨越三十年的家族史诗，讲述两代人在时代洪流中的坚守与抉择，用细腻笔触描摹普通人与家国的共同命运。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20illustration%20of%20a%20nostalgic%20old%20town%20street%20at%20dawn%20with%20warm%20golden%20sunrise%20light%20and%20a%20solitary%20figure%2C%20historical%20drama%20mood%2C%20amber%20and%20teal%20palette%2C%20painterly%20texture&width=400&height=600&seq=mv-changye-03&orientation=portrait",
    tags: ["年度剧王", "催泪"],
    hot: true,
  },
  {
    id: "shenhai-huisheng",
    title: "深海回声",
    type: "movie",
    genres: ["科幻", "惊悚", "冒险"],
    region: "美国",
    year: 2025,
    rating: 7.8,
    duration: "126分钟",
    director: "Ethan Cole",
    cast: ["Mia Reeves", "Daniel Park", "Leo Grant"],
    synopsis:
      "一支深海科考队在万米海沟遭遇未知生物，密闭的潜水器成为孤岛，人类必须在恐惧与理智之间做出选择。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20illustration%20of%20a%20deep%20ocean%20abyss%20with%20a%20small%20submarine%20illuminated%20by%20a%20faint%20light%20beam%2C%20dark%20teal%20and%20cyan%20tones%2C%20eerie%20underwater%20atmosphere%2C%20minimalist%20sci-fi%20composition&width=400&height=600&seq=mv-shenhai-04&orientation=portrait",
    tags: ["深海", "惊悚"],
    hot: false,
  },
  {
    id: "gucheng-jiunmeng",
    title: "故城旧梦",
    type: "tv",
    genres: ["爱情", "年代", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.4,
    duration: "全40集",
    director: "林知夏",
    cast: ["白鹿", "张彬彬", "李沁"],
    synopsis:
      "民国江南小城里，一段跨越阶级的爱情在动荡岁月中悄然生长，故城的青石板路见证了他们的相遇与别离。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20illustration%20of%20a%20romantic%20old%20southern%20town%20canal%20with%20lanterns%20reflecting%20on%20water%20at%20dusk%2C%20warm%20amber%20and%20rose%20tones%2C%20nostalgic%20period%20drama%20mood%2C%20painterly%20texture&width=400&height=600&seq=mv-gucheng-05&orientation=portrait",
    tags: ["甜虐", "民国"],
    hot: true,
  },
  {
    id: "wuming-zhizhi-2",
    title: "无名之辈2",
    type: "movie",
    genres: ["喜剧", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.0,
    duration: "112分钟",
    director: "饶晓志",
    cast: ["章宇", "任素汐", "陈建斌"],
    synopsis:
      "一群小城小人物的荒诞故事再度上演，笑中带泪的市井烟火里，藏着每个平凡人对尊严的倔强坚持。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20illustration%20of%20a%20lively%20small%20town%20street%20market%20at%20golden%20hour%20with%20colorful%20characters%20among%20stalls%2C%20warm%20orange%20and%20teal%20tones%2C%20quirky%20comedic%20mood%2C%20minimalist%20composition&width=400&height=600&seq=mv-wuming-06&orientation=portrait",
    tags: ["喜剧", "温情"],
    hot: false,
  },
  {
    id: "jiye-xingdong",
    title: "极夜行动",
    type: "tv",
    genres: ["动作", "谍战", "悬疑"],
    region: "中国大陆",
    year: 2025,
    rating: 8.6,
    duration: "全30集",
    director: "高群书",
    cast: ["张译", "王凯", "倪大红"],
    synopsis:
      "冷战格局下的暗战风云，一位潜伏多年的情报人员必须在极昼极夜交替的边境小城完成最后的任务，身份随时可能暴露。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20illustration%20of%20a%20snowy%20northern%20border%20town%20under%20aurora%20night%20sky%20with%20a%20lone%20agent%20silhouette%2C%20cold%20blue%20and%20warm%20amber%20contrast%2C%20tense%20espionage%20atmosphere%2C%20minimalist%20composition&width=400&height=600&seq=mv-jiye-07&orientation=portrait",
    tags: ["谍战", "高分"],
    hot: true,
  },
  {
    id: "chunri-youju",
    title: "春日邮局",
    type: "movie",
    genres: ["爱情", "文艺", "治愈"],
    region: "日本",
    year: 2024,
    rating: 8.3,
    duration: "108分钟",
    director: "岩井俊二",
    cast: ["广濑铃", "菅田将晖", "松隆子"],
    synopsis:
      "樱花盛开的季节里，一间濒临关闭的乡村邮局串联起陌生人的书信与心事，一段温柔的邂逅在信纸间慢慢展开。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20illustration%20of%20a%20small%20Japanese%20rural%20post%20office%20surrounded%20by%20blooming%20cherry%20blossom%20trees%20in%20soft%20pink%20daylight%2C%20gentle%20pastel%20tones%2C%20tender%20healing%20mood%2C%20painterly%20texture&width=400&height=600&seq=mv-chunri-08&orientation=portrait",
    tags: ["治愈", "文艺"],
    hot: false,
  },
  {
    id: "huangyuan-qishi",
    title: "荒原骑士",
    type: "movie",
    genres: ["西部", "动作", "冒险"],
    region: "美国",
    year: 2023,
    rating: 7.5,
    duration: "134分钟",
    director: "Samuel Reed",
    cast: ["Jack Morrow", "Ella Vance", "Owen Blake"],
    synopsis:
      "在法外之地，一名沉默的赏金猎人护送神秘少女穿越荒原，逐渐揭开一场关于复仇与救赎的西部传奇。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20illustration%20of%20a%20lone%20rider%20on%20horseback%20crossing%20a%20dusty%20desert%20canyon%20at%20sunset%2C%20warm%20orange%20and%20dusty%20brown%20palette%2C%20western%20adventure%20mood%2C%20minimalist%20composition&width=400&height=600&seq=mv-huangyuan-09&orientation=portrait",
    tags: ["西部", "硬核"],
    hot: false,
  },
  {
    id: "shanhai-zhijian",
    title: "山与海之间",
    type: "tv",
    genres: ["家庭", "治愈", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 8.8,
    duration: "全24集",
    director: "王小帅",
    cast: ["刘琳", "秦昊", "谭卓"],
    synopsis:
      "一位城市返乡的年轻人接手父亲留下的海边民宿，在迎来送往的旅人故事中，渐渐理解了家庭与故乡的深意。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20illustration%20of%20a%20cozy%20seaside%20guesthouse%20perched%20on%20a%20rocky%20coast%20with%20distant%20mountains%2C%20soft%20blue%20and%20warm%20cream%20tones%2C%20calm%20healing%20atmosphere%2C%20painterly%20texture&width=400&height=600&seq=mv-shanhai-10&orientation=portrait",
    tags: ["治愈", "家庭"],
    hot: true,
  },
  {
    id: "jianying-changge",
    title: "剑影长歌",
    type: "movie",
    genres: ["古装", "武侠", "动作"],
    region: "中国大陆",
    year: 2025,
    rating: 8.1,
    duration: "138分钟",
    director: "徐皓峰",
    cast: ["张震", "周迅", "此沙"],
    synopsis:
      "江湖动荡，一名隐世剑客为重振师门踏入纷争，刀光剑影之间，关于道义与恩怨的史诗缓缓上演。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20illustration%20of%20a%20lone%20swordsman%20standing%20on%20a%20misty%20mountain%20peak%20with%20flowing%20robes%2C%20ink-wash%20martial%20arts%20aesthetic%2C%20muted%20blue%20and%20warm%20gold%20tones%2C%20minimalist%20composition&width=400&height=600&seq=mv-jianying-11&orientation=portrait",
    tags: ["武侠", "国风"],
    hot: true,
  },
  {
    id: "jingmo-zhicheng",
    title: "静默之城",
    type: "tv",
    genres: ["悬疑", "科幻", "剧情"],
    region: "英国",
    year: 2025,
    rating: 8.5,
    duration: "全10集",
    director: "Oliver Finch",
    cast: ["Emma Stone", "Tom Hardy", "Rebecca Hall"],
    synopsis:
      "在一座所有人突然失去声音的都市里，一位语言学家试图破解诡异现象背后的真相，却发现沉默才是最大的秘密。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20illustration%20of%20an%20empty%20modern%20city%20street%20shrouded%20in%20pale%20mist%20with%20a%20lone%20figure%2C%20desaturated%20blue%20and%20grey%20tones%2C%20eerie%20sci-fi%20mystery%20atmosphere%2C%20minimalist%20composition&width=400&height=600&seq=mv-jingmo-12&orientation=portrait",
    tags: ["科幻", "神剧"],
    hot: false,
  },
  {
    id: "zhuifeng-shaonian",
    title: "追风少年",
    type: "movie",
    genres: ["青春", "运动", "剧情"],
    region: "中国大陆",
    year: 2024,
    rating: 7.9,
    duration: "116分钟",
    director: "陈可辛",
    cast: ["易烊千玺", "张子枫", "王砚辉"],
    synopsis:
      "小镇少年怀揣短跑梦想，在质疑与伤痛中一次次起跑，用汗水与坚持书写属于自己的青春赛道。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20illustration%20of%20a%20young%20athlete%20sprinting%20on%20a%20running%20track%20at%20dawn%20with%20motion%20blur%2C%20warm%20orange%20and%20sky%20blue%20tones%2C%20energetic%20youthful%20mood%2C%20minimalist%20composition&width=400&height=600&seq=mv-zhuifeng-13&orientation=portrait",
    tags: ["青春", "励志"],
    hot: false,
  },
  {
    id: "xinghe-lvren",
    title: "星河旅人",
    type: "movie",
    genres: ["科幻", "爱情", "剧情"],
    region: "法国",
    year: 2023,
    rating: 8.2,
    duration: "124分钟",
    director: "Luc Moreau",
    cast: ["Clara Dubois", "Antoine Roux", "Juliette Leroy"],
    synopsis:
      "一名穿梭于星际航线的旅人与地球上的女孩通过延迟信号相爱，跨越光年的通信里，他们丈量着思念的距离。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20illustration%20of%20a%20spacecraft%20drifting%20near%20a%20glowing%20purple%20nebula%20with%20a%20distant%20blue%20planet%2C%20poetic%20sci-fi%20romance%20mood%2C%20soft%20violet%20and%20teal%20tones%2C%20minimalist%20composition&width=400&height=600&seq=mv-xinghe-14&orientation=portrait",
    tags: ["科幻", "浪漫"],
    hot: false,
  },
  {
    id: "dushi-mian",
    title: "都市迷案",
    type: "tv",
    genres: ["悬疑", "刑侦", "剧情"],
    region: "中国大陆",
    year: 2025,
    rating: 8.7,
    duration: "全36集",
    director: "五百",
    cast: ["潘粤明", "张若昀", "王鸥"],
    synopsis:
      "一系列看似无关的都市案件背后隐藏着同一个真相，刑警队长与天才法医联手抽丝剥茧，揭开都市光影下的隐秘角落。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20illustration%20of%20a%20neon-lit%20modern%20city%20detective%20scene%20at%20night%20with%20rain-slicked%20streets%2C%20deep%20blue%20and%20orange%20neon%20tones%2C%20tense%20crime%20drama%20atmosphere%2C%20minimalist%20composition&width=400&height=600&seq=mv-dushi-15&orientation=portrait",
    tags: ["刑侦", "高分"],
    hot: true,
  },
  {
    id: "baizhou-zhiyu",
    title: "白昼之雨",
    type: "movie",
    genres: ["剧情", "悬疑", "惊悚"],
    region: "日本",
    year: 2024,
    rating: 7.7,
    duration: "120分钟",
    director: "白石和弥",
    cast: ["绫野刚", "松山研一", "二阶堂富美"],
    synopsis:
      "一个平凡青年的平静生活被旧日同窗的突然出现彻底打破，白昼之下的雨，冲刷出一段压抑已久的黑暗过往。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20poster%20illustration%20of%20a%20quiet%20suburban%20street%20under%20bright%20daytime%20rain%20with%20a%20solitary%20figure%20holding%20an%20umbrella%2C%20muted%20green%20and%20grey%20tones%2C%20unsettling%20thriller%20mood%2C%20minimalist%20composition&width=400&height=600&seq=mv-baizhou-16&orientation=portrait",
    tags: ["悬疑", "日影"],
    hot: false,
  },
];